import {
  EVButton,
  EVDialog,
  EVDialogActions,
  EVDialogContent,
  EVDialogContentText,
  EVDialogTitle,
} from 'lib/components';
import PropTypes from 'prop-types';
import React from 'lib/react';
import ValidationMessageDialogStyles from './ValidationMessageDialogStyles';
/** Component that renders dialog box for showing validation messages */
function ValidationMessageDialog(props) {
  const {
    title,
    message,
    open,
    handleClose,
    cancelButtonText,
    okayButtonText,
    handleNext,
    isNext,
    cancelButtonClass,
    okayButtonClass,
  } = props;
  const classes = ValidationMessageDialogStyles();

  const handleOkayButtonClick = () => {
    handleClose();
    if (isNext && handleNext) handleNext();
  };

  return (
    <EVDialog
      open={open}
      onClose={handleClose}
      classes={{ paper: classes.dialog }}
    >
      <EVDialogTitle disableTypography className={classes.title}>{title}</EVDialogTitle>
      <EVDialogContent>
        <EVDialogContentText className={classes.contentText}>
          {message}
        </EVDialogContentText>
      </EVDialogContent>
      <EVDialogActions className={classes.actions}>
        {cancelButtonText && (
          <EVButton onClick={handleClose} color="primary" variant="outlined" className={cancelButtonClass} id="cancel-btn">
            {cancelButtonText}
          </EVButton>
        )}
        {okayButtonText && (
          <EVButton onClick={handleOkayButtonClick} color="primary" variant="contained" className={okayButtonClass} id="okay-btn">
            {okayButtonText}
          </EVButton>
        )}
      </EVDialogActions>
    </EVDialog>
  );
}

ValidationMessageDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  okayButtonText: PropTypes.string,
  handleNext: PropTypes.func,
  isNext: PropTypes.bool,
  cancelButtonClass: PropTypes.string,
  okayButtonClass: PropTypes.string,
};

ValidationMessageDialog.defaultProps = {
  cancelButtonText: '',
  okayButtonText: '',
  handleNext: null,
  isNext: false,
  cancelButtonClass: '',
  okayButtonClass: '',
};

export default ValidationMessageDialog;
